import { showDeleteModal } from '@/components/financialEntities/DeleteModal';
import { ExternalFinancialEntity } from '@common/financialEntities/types';
import { showConfirmModal } from '../common/modals/ConfirmModal';

export const showLongFetchTimeModal = (
    externalFinancialEntity?: ExternalFinancialEntity
) => {
    showConfirmModal({
        title: 'Balances are on the way',
        description:
            'We know waiting isn’t ideal. Some institutions take longer to provide data, but rest assured, we’re monitoring the process and will have your balances ready as soon as possible.',
        buttonText: 'Got it',
        onConfirm: async () => {},
        secondaryButtonText: externalFinancialEntity
            ? 'Delete Account'
            : undefined,
        secondaryButtonProps: externalFinancialEntity
            ? {
                  colorScheme: 'red',
              }
            : undefined,
        onSecondaryButton: externalFinancialEntity
            ? async () => {
                  showDeleteModal({
                      financialEntity: externalFinancialEntity,
                      onComplete: () => {},
                  });
              }
            : undefined,
        onClickPrimaryEvent: 'Long Fetch Time Modal - Got It Button Clicked',
        onClickSecondaryEvent:
            'Long Fetch Time Modal - Delete Account Button Clicked',
    });
};
